export const SHINY_CLASS = 'shiny';

export function isShinyPokemon(pokemon) {
  return Boolean(pokemon?.shiny);
}

export function shinyClass(pokemon) {
  return isShinyPokemon(pokemon) ? SHINY_CLASS : '';
}

export function matchesShinyFilter(pokemon, shinyOnly = false) {
  return !shinyOnly || isShinyPokemon(pokemon);
}
